import useJwt from '@/auth/jwt/useJwt'

export default {
  namespaced: true,
  state: {
    info: {},
  },
  getters: {},
  mutations: {
    UPDATE_USER_INFO(state, val) {
      state.info = val
    },
  },
  actions: {
    getUserInfo({ commit }) {
      useJwt.axiosIns.get('/users/info').then(res => {
        commit('UPDATE_USER_INFO', res.data)
      })
    },
  },
}
